import type { PassTier } from '../data/placesIndex'

/** Pełny Paszport (60 miejsc) widoczny publicznie na landing, formularzu i w cenniku. */
export const FULL_PASS_PUBLIC_ENABLED = false

export function resolvePublicPassTier(tier: PassTier): PassTier {
  if (FULL_PASS_PUBLIC_ENABLED) return tier
  return 'mini'
}

export function publicCopyKey<K extends string>(whenFullEnabled: K, whenMiniOnly: K): K {
  return FULL_PASS_PUBLIC_ENABLED ? whenFullEnabled : whenMiniOnly
}
